import { classNames } from "@opensea/ui-kit"

export const containedMediaClassNames = classNames(
  "aspect-square overflow-hidden rounded-lg bg-component-gray-1 object-contain",
)
